import {Injectable, signal} from '@angular/core';
import {FileTypeName} from "../../../../../core/types/file.types";
import {PasteEnabledState} from "../types/paste-enabled-state.types";

@Injectable({
  providedIn: 'root'
})
export class PasteEnabledStateService {
  private _isPasteEnabledState = signal<PasteEnabledState>({});

  public isPasteEnabled(type: FileTypeName): boolean {
    return Boolean(this._isPasteEnabledState()[type]);
  }

  public setPasteEnabled(type: FileTypeName, enabled: boolean): void {
    !this._isPasteEnabledState() ?
      this.initializeState(type, enabled) :
      this.disableAllOtherTypes(type, enabled);
  }

  public deletePasteEnabledState(activeType: FileTypeName): void {
    this._isPasteEnabledState.update(currentState => {
      const newState = { ...currentState };
      delete newState[activeType];

      return newState;
    });
  }

  private initializeState(type: FileTypeName, enabled: boolean): void {
    this._isPasteEnabledState.set({ [type]: enabled });
  }

  private disableAllOtherTypes(activeType: FileTypeName, enabled: boolean): void {
    this._isPasteEnabledState.update(currentState => {
      const newState = Object.keys(currentState).reduce((acc, key) => {
        acc[key as FileTypeName] = key === activeType ? enabled : false;
        return acc;
      }, {} as PasteEnabledState);

      if (!(activeType in currentState)) {
        newState[activeType] = enabled;
      }

      return newState;
    });
  }
}
